import React, { useState } from 'react';
import { 
  Clipboard, 
  Users, 
  Tag, 
  UsersRound, 
  Settings, 
  Clock,
  Layers,
  TagIcon,
  MapPin,
  Bell,
  Image,
  Megaphone,
  Workflow,
  Wrench,
  UserCircle,
  Share2,
  ChevronRight
} from 'lucide-react';

const Maintenance = ({ handlePageChange }) => {
  const [selectedCard, setSelectedCard] = useState(null);

  const maintenanceCards = [
    {
      id: 'IssueTypePage',
      title: 'IssueType Management',
      icon: Clipboard,
      description: 'Manage different types of issues'
    },
    {
      id: 'AffectedPage',
      title: 'Affected Management',
      icon: Users,
      description: 'Handle affected parties'
    },
    {
      id: 'TagsPage',
      title: 'Tags Management',
      icon: Tag,
      description: 'Create and organize tags'
    },
    {
      id: 'teams',
      title: 'Teams Management',
      icon: UsersRound,
      description: 'Manage teams and assignments'
    },
    {
      id: 'ComponentsPage',
      title: 'Components Management',
      icon: Settings,
      description: 'Configure system components'
    },
    {
      id: 'CategoryPage',
      title: 'Category Management',
      icon: Layers,
      description: 'Organize content categories'
    },
    {
      id: 'SLAPage',
      title: 'SLAs Management',
      icon: Clock,
      description: 'Set up service level agreements'
    },
    {
      id: 'OriginsPage',
      title: 'Manage Origins',
      icon: MapPin,
      description: 'Configure ticket origins'
    },
    {
      id: 'gallery',
      title: 'Gallery',
      icon: Image,
      description: 'Manage media and images'
    },
    {
      id: 'FeedbackPage',
      title: 'Feedback',
      icon: Megaphone,
      description: 'View and manage feedback'
    },
    {
      id: 'RequestTypePage',
      title: 'RequestTypePage',
      icon: MapPin,
      description: 'Configure location settings'
    },
    {
      id: 'notifications',
      title: 'Notifications',
      icon: Bell,
      description: 'Manage notification settings'
    },
    {
      id: 'automation',
      title: 'Automation',
      icon: Workflow,
      description: 'Set up automated workflows'
    },
    {
      id: 'additional',
      title: 'Additional',
      icon: Wrench,
      description: 'Additional configurations'
    },
    {
      id: 'contact',
      title: 'Contact Display',
      icon: UserCircle,
      description: 'Manage contact information'
    },
    {
      id: 'services',
      title: 'Services',
      icon: Share2,
      description: 'Configure available services'
    },

    {
      id: 'WebsiteInfoPage',
      title: 'WebsiteInfoPage',
      icon: Workflow,
      description: 'Set up automated workflows'
    },

    
  ];

const handleCardClick = (cardId) => {
  setSelectedCard(cardId);
  handlePageChange(cardId); // ✅ ITO ANG KULANG
};


  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-100 mb-2">
          Maintenance
        </h1>
        <p className="text-gray-400 text-sm md:text-base">
          Configure and manage system settings
        </p>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {maintenanceCards.map((card) => {
          const IconComponent = card.icon;
          const isSelected = selectedCard === card.id;

          return (
            <div
              key={card.id}
              onClick={() => handleCardClick(card.id)}
              className={`
                relative group cursor-pointer
                bg-gradient-to-br from-slate-800 to-slate-900
                rounded-xl p-6
                border border-slate-700
                shadow-md hover:shadow-xl
                transform transition-all duration-300
                hover:scale-[1.02] hover:-translate-y-1
                hover:border-slate-600
                ${isSelected ? 'ring-2 ring-blue-500 border-blue-500' : ''}
              `}
            >
              {/* Content */}
              <div className="flex items-center justify-between">
                {/* Left Side - Icon & Title */}
                <div className="flex items-center gap-4 flex-1">
                  <div className="w-12 h-12 bg-slate-700 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-slate-600 transition-colors">
                    <IconComponent className="w-6 h-6 text-gray-300 group-hover:text-white transition-colors" />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <h3 className="text-base font-semibold text-gray-100 mb-1 group-hover:text-white transition-colors">
                      {card.title}
                    </h3>
                    <p className="text-xs text-gray-400 line-clamp-1">
                      {card.description}
                    </p>
                  </div>
                </div>

                {/* Right Side - Arrow */}
                <div className="ml-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <ChevronRight className="w-5 h-5 text-gray-400" />
                </div>
              </div>

              {/* Subtle Shine Effect */}
              <div className="absolute inset-0 rounded-xl overflow-hidden pointer-events-none">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-[0.03] transform -skew-x-12 translate-x-full group-hover:translate-x-[-200%] transition-all duration-1000" />
              </div>
            </div>
          );
        })}
      </div>

      {/* Info Section */}
      <div className="mt-8 bg-slate-800 rounded-xl p-5 border border-slate-700">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-slate-700 rounded-lg flex items-center justify-center flex-shrink-0">
            <Settings className="w-5 h-5 text-gray-300" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-gray-100 mb-1">
              Quick Tip
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Click on any card to manage its settings. Each module allows you to configure 
              specific aspects of your helpdesk system.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;